import { PieChart, pieChartDefaultProps } from 'react-minimal-pie-chart';

import { theme } from '@styles/theme';

import { JobStatisticsSources } from 'types/jobs';

type Props = {
  sources: JobStatisticsSources;
};

export function SourcedDoughnut({ sources }: Props) {
  const { manuallyAdded, sourced, urls } = sources;

  return (
    <PieChart
      style={{ width: '5rem', height: '5rem' }}
      radius={pieChartDefaultProps.radius - 6}
      lineWidth={40}
      background={theme.color.purple10}
      animate
      data={[
        { value: urls.direct?.count ?? 0, color: theme.color.green100 },
        { value: sourced, color: theme.color.blue100 },
        { value: manuallyAdded, color: theme.color.purple200 },
      ]}
    />
  );
}
